import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=2e3fedf6&scoped=true&"
import script from "./LogoCard.vue?vue&type=script&lang=ts&"
export * from "./LogoCard.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCard.vue?vue&type=style&index=0&id=2e3fedf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fedf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3fedf6')) {
      api.createRecord('2e3fedf6', component.options)
    } else {
      api.reload('2e3fedf6', component.options)
    }
    module.hot.accept("./LogoCard.vue?vue&type=template&id=2e3fedf6&scoped=true&", function () {
      api.rerender('2e3fedf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/logo/LogoCard.vue"
export default component.exports